import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ProfileTraderClub } from '@hub-workspace/apps/logged-home/src/app/state-management/club-trader/club-trader.reducer';
import { Store } from '@ngrx/store';
import { ModalComponent } from '@toro/common/shared/components/modal/modal.component';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
  selector: 'trader-trial-modal',
  templateUrl: './trader-trial-modal.component.html',
  styleUrls: ['./trader-trial-modal.component.scss'],
})
export class TraderTrialModalComponent implements OnChanges {
  @Input() duration?: number = 0;
  @Input() expired?: boolean = false;
  @Input() activated?: boolean = false;
  @Input() minimum?: number = 0;
  @Input() currentMonth?: number = 0;
  @Input() vip?: boolean = false;
  @Input() profile?: ProfileTraderClub;
  public topRankValue: string = '5000';

  @Output() trialActivated = new EventEmitter<void>();

  @ViewChild(ModalComponent, { static: false })
  public modalTrial!: ModalComponent;

  constructor(private store: Store<any>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profile'] && changes['profile'].currentValue) {
      this.calculateTopRank();
    }
  }

  public onOpen() {
    this.modalTrial.show();
    if (!this.activated) {
      this.sendTracking('Modal Opened', {
        'Product Area Origin': 'Home Trader',
        Scenario: 'Interesse no Trial do Trader Vip',
        Step: 'Tela de aceite',
        Status: 'Trial Inativo',
        Text: 'Aproveite os benefícios de ser Trader VIP',
        'Time Responsável': 'Sky',
      });
      return;
    }

    if (!this.expired) {
      this.sendTracking('Modal Opened', {
        'Product Area Origin': 'Home Trader',
        Scenario: 'Iniciou o Trial do Trader Vip',
        Step: 'Feedback de sucesso',
        Status: 'Trial Ativo',
        Text: 'Aumente suas possibilidades de ganhos! Comece a operar com as recomendações dos nossos especialistas',
        'Time Responsável': 'Sky',
      });
      return;
    }

    if (this.vip) {
      this.sendTracking('Modal Opened', {
        'Product Area Origin': 'Home Trader',
        Scenario: 'Se tornou Trader Vip no período de teste',
        Step: 'Fim do Período de Teste',
        Status: 'Trader Vip Ativo',
        Text: 'Parabéns! Você faz parte do Trader Vip.',
        'Time Responsável': 'Sky',
      });
      return;
    }

    if (this.currentMonth) {
      this.sendTracking('Modal Opened', {
        'Product Area Origin': 'Home Trader',
        Scenario: 'Operou no período de teste',
        Step: 'Fim do Período de Teste',
        Status: 'Trial Trader Vip Encerrado',
        Text: 'Seu período de teste do Trader VIP acabou!',
        'Time Responsável': 'Sky',
      });
      return;
    }

    if (!this.currentMonth) {
      this.sendTracking('Modal Opened', {
        'Product Area Origin': 'Home Trader',
        Scenario: 'Não operou no período de teste',
        Step: 'Fim do Período de Teste',
        Status: 'Trial Trader Vip Encerrado',
        Text: 'Seu período de teste do Trader VIP acabou!',
        'Time Responsável': 'Sky',
      });
      return;
    }
  }

  public onClose() {
    this.modalTrial.hide();
  }

  public onActivateTrial() {
    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Home Trader',
      Element: 'Botão Experimentar por 15 dias',
      Group: 'Modal Trial Trader Vip',
      Step: 'Tela de aceite',
      Text: 'Aproveite os benefícios de ser Trader VIP',
      'Time Responsável': 'Sky',
    });
    this.trialActivated.emit();
  }

  public onCheckInsights() {
    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Home Trader',
      Element: 'Botão Entrar no canal de insights',
      Group: 'Modal Trial Trader Vip',
      Step: 'Feedback de sucesso',
      Text: 'Aumente suas possibilidades de ganhos! Comece a operar com as recomendações dos nossos especialistas',
      'Time Responsável': 'Sky',
    });
    window.open('https://t.me/+0lvP3j0cIehkNjcx', '_blank');
  }

  public onCheckAdvancedPlatforms() {
    this.sendTracking('Element Clicked', {
      'Product Area Origin': 'Home Trader',
      Element: 'Botão Acessar Plataforma Avançada',
      Group: 'Modal Fim do Trial Trader VIP',
      Step: 'Fim do Período de Teste',
      Text: 'Seu período de teste do Trader VIP acabou!',
      'Specific Properties': {
        'Operou durante o Trial': this.currentMonth > 0,
      },
      'Time Responsável': 'Sky',
    });
    this.navigateTo('/plataformas/toro-trader', true);
  }

  public navigateTo(path: string, blank: boolean = false) {
    if (blank) {
      window.open(path, '_blank');
    }
    window.location.href = path;
  }

  public sendTracking(event: string, breakdowns: any) {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: { type: event, events: breakdowns },
    });
  }

  private calculateTopRank(): void {
    if (!this.profile?.rankingPosition || this.profile?.rankingPosition === 0) {
      this.topRankValue = '5000';
    } else if (this.profile?.rankingPosition <= 100) {
      this.topRankValue = '100';
    } else if (this.profile?.rankingPosition <= 500) {
      this.topRankValue = '500';
    } else if (this.profile?.rankingPosition <= 1000) {
      this.topRankValue = '1.000';
    } else {
      this.topRankValue = '5.000';
    }
  }
}
